;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import clsx from 'clsx'
import type { ComponentPropsWithoutRef } from 'react'

import { PageErrorCodeOptions } from './page-error.interface'

type PageErrorCodeProps = Omit<ComponentPropsWithoutRef<'h2'>, 'children'> & {
  httpCode: PageErrorCodeOptions
}

export function PageErrorCode({
  className,
  httpCode,
  ...props
}: PageErrorCodeProps) {
  return (
    <h2
      {...props}
      className={clsx(
        'text-primary-500 text-[175px] leading-none font-extrabold md:text-[250px]',
        className,
      )}
    >
      {httpCode}
    </h2>
  )
}
